import { useCallback } from 'react';
import { useTellerSession } from '~/common/hooks/use-auth/use-teller-session';
import { useRequireVipOnlyStoryModal } from '@app/(default-layout)/se/[seriesId]/_containers/require-vip-only-story-modal-container';

export const useLocalHooks = () => {
  const { session } = useTellerSession();
  const {
    open: openRequireVipOnlyStoryModal,
    close: closeRequireVipOnlyStoryModal,
  } = useRequireVipOnlyStoryModal();

  const showVipOnlyModal = useCallback(
    (e: React.MouseEvent<HTMLDivElement, MouseEvent>, storyId: string) => {
      e.preventDefault();
      e.stopPropagation();
      openRequireVipOnlyStoryModal(storyId);
    },
    [openRequireVipOnlyStoryModal]
  );

  const closeVipOnlyModal = useCallback(() => {
    closeRequireVipOnlyStoryModal();
  }, [closeRequireVipOnlyStoryModal]);

  return {
    showVipOnlyModal,
    closeVipOnlyModal,
    userIsVip: session?.tellerUser?.isVipUser || false,
  };
};
